import { PlaceholdersId, TFComponent } from '@types';
import { AvailableAccountListPlaceholder } from './availableAccountList';

export const availableAccountList: TFComponent = {
	component: AvailableAccountListPlaceholder,
	id: PlaceholdersId.availableAccountList,
	name: 'availableAccountList',
};
